<template>
    <div>
      <!-- Modal Structure -->
      <div
        v-if="isLoading"
        class="modal loadingPage"
        tabindex="1"
        id="modal-loading"
      >
        <div class="modal-dialog">
          <div class="pill">
            <div class="text-center">
              <div class="loading-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Layer_2"
                  viewBox="0 0 82.254 80"
                  class="pulsating-spinner"
                >
                  <g id="BlackFontColoredLogo">
                    <g>
                      <path
                        class="cls-1"
                        d="M32.663 3.738q0.288 -0.382 0.633 -0.736c-0.411 0.419 -0.806 0.868 -1.135 1.382L0 73.268c3.377 5.988 14.793 5.741 18.791 -0.354L41.662 22.809l-0.465 -0.987z"
                      />
                      <path
                        class="cls-2"
                        d="M81.666 67.975 50.241 4.38a9.048 9.048 0 0 0 -1.402 -1.641 8.225 8.225 0 0 0 -0.6 -0.518l-0.271 -0.197c-1.929 -1.386 -4.359 -2.04 -6.765 -2.023 -2.492 0.016 -4.943 0.728 -6.765 2.028l-0.271 0.197a8.225 8.225 0 0 0 -0.6 0.518L33.301 3.002a8.225 8.225 0 0 0 -0.633 0.736l8.534 18.084 0.465 0.987 26.552 56.233c1.345 2.295 17.282 1.147 13.449 -11.067"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isLoading: true, // Control the visibility of the modal
      };
    },
    methods: {
      showModal() {
        this.isLoading = true;
      },
      hideModal() {
        this.isLoading = false;
      },
    },
  };
  </script>
  
  <style>
  .cls-1 {
    fill: #a3c0d1;
    width: 20px;
  }
  
  .cls-2 {
    fill: #00a0c1;
  }
  </style>
  
  <style scoped>
.loadingPage {
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 999999 !important;
}

.pulsating-spinner {
  width: 100%; /* Make the SVG responsive */
  height: 100%;
  animation: pulse 1.5s infinite;
}

.modal-dialog {
  padding: 0 !important;
  margin: 0 !important;
  width: 100px !important;
  max-width: 100px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>